import * as React from "react";

import chargifyLogo from "./chargifyLogo.jpeg";
import { GraphicProps } from "./types";

const DEFAULT_SIZE = 24;

const ChargifyLogoSvg: React.FC<GraphicProps> = ({
  size = DEFAULT_SIZE,
  style,
  onClick,
}) => {
  return (
    <img
      src={chargifyLogo}
      alt="Chargify"
      width={size}
      height={size}
      style={{
        borderRadius: "50%",
        verticalAlign: "middle",
        ...style,
        cursor: onClick ? "pointer" : undefined,
      }}
      onClick={onClick}
    />
  );
};

export default ChargifyLogoSvg;
